import React, { FunctionComponent } from 'react'
import { Link } from "react-router-dom"
import classNames from 'classnames'
import { useTranslation } from "react-i18next"
import moment from 'moment'
import style from "./Revisions.scss"

import { IRevision, ISkinTrack } from '../ISkinTrack'

interface IProps {
    skinTrack: ISkinTrack
    currentRevision: IRevision
}

const Revisions: FunctionComponent<IProps> = ({skinTrack, currentRevision}) => {
    const {t} = useTranslation()

    return (
        <div className={style.history}>
            <h3>{t('History')}</h3>
            <div className={style.timeline}>
                {
                    skinTrack.revisions.length === 0 ? <p>Loading...</p> : (
                        skinTrack.revisions.map(
                            (revision) => {
                                let date = moment(revision.revision).format('dddd DD MMMM YYYY')

                                let classes = classNames({
                                    [style.item]: true,
                                    [style.active]: currentRevision.revision === revision.revision
                                })

                                return (
                                    <div className={classes} key={revision.revision}>
                                        <Link
                                            className={style.date}
                                            to={'/customers/' + skinTrack.customerUuid + '/skin-track/' + skinTrack.limb + '/' + revision.revision}
                                        >
                                            {date}
                                        </Link>
                                    </div>
                                )
                            }
                        )
                    )
                }
            </div>
        </div>
    )
}

export default Revisions
